module.exports = __webpack_public_path__ + "img/1530098004.750c999c.jpg";